import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationDataService {
  private notificationCountSubject: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  getNotificationCount(): Observable<number> {
    return this.notificationCountSubject.asObservable();
  }

  updateNotificationCount(count: number) {
    this.notificationCountSubject.next(count);
  }

  incrementNotificationCount() {
    const currentCount = this.notificationCountSubject.value;
    this.notificationCountSubject.next(currentCount + 1);
  }
}
